import * as React from "react";
import { Icon } from "@iconify/react";
import firebase from "firebase";
import { removeAllCookies } from "../../../../utils/cookies";
import SocialSignInButton from "../../../../components/buttons/SocialSignInButton";
import SocialSignInButtonWithLogo from "../../../../components/buttons/SocialSignInButtonWithLogo";

export interface GoogleSignInProps {
  handleCreateCustomToken: any;
  backText: any;
  backColour: any;
}

/* Google sign in page */
const GoogleSignIn: React.FunctionComponent<GoogleSignInProps> = ({
  handleCreateCustomToken,
  backText,
  backColour,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleLogout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        // Sign-out successful.
        removeAllCookies();
        localStorage.clear();
        window.location.href = `${process.env.REACT_APP_PRESTO_ACCOUNT_DOMAIN}/accounts/sign-in`;
      })
      .catch((error) => {
        console.error("error", error);
      });
  };

  const handleClick = () => {
    setIsLoading(true);
    const provider = new firebase.auth.GoogleAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result: any) => {
        if (result && result.user) {
          firebase.auth().onAuthStateChanged((firebaseUser) => {
            if (firebaseUser) {
              firebaseUser.getIdToken(true).then(async function (idToken) {
                handleCreateCustomToken(idToken);
              });
            }
          });
        }
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const { email } = error;
        // The firebase.auth.AuthCredential type that was used.
        const { credential } = error;
        setIsLoading(false);
      });
  };
  return (
    <SocialSignInButtonWithLogo
      handleClick={handleClick}
      logoSrc={
        <Icon
          icon="ri:google-fill"
          style={{
            width: "32px",
            minWidth: "32px",
            height: "32px",
          }}
          color={backText}
        />
      }
      isLoading={isLoading}
      backColour={backColour}
    />
  );
};

export default GoogleSignIn;
